import { useIntl } from 'react-intl';
import { Navbar as PageNavbar } from '@components/servizi-soluzioni/navbar/navbar';
import { Container } from '@components/servizi-soluzioni/container/container';
import { getObjectValue } from '@services/object-extensions';
import { ScrollToTop } from '@components/servizi-soluzioni/scroll-to-top/scroll-to-top';
import cn from 'classnames';
import { useEffect, useState } from 'react';
import { TIMEOUT } from '@constants/components/timeout';
import { PageHead } from '../../common/head/page-head';
import { Navbar } from '../../common/navbar/navbar';
import styles from './layout-desktop.module.css';
import { SettoriIndustriaSezione } from '../dettaglio/dettaglio';
import { SezionePrincipale } from '../sezione-principale/sezione-principale';

export default function SettoriIndustriaDesktop({
  pages = [],
  mainSectionDescriptions = {},
  mainSectionImageUrl = '',
  mainSectionDarkTheme = false,
  navbarItems = [],
  serviceCategories = [],
  technologyCategories = []
}) {
  const intl = useIntl();
  const [navMobileState, setNavMobileState] = useState({ isOpen: false });
  useEffect(() => {
    setTimeout(() => {
      const { hash } = window.location;
      window.location.hash = '';
      window.location.hash = hash;
    }, TIMEOUT);
  }, []);
  return (
    <div
      className="snf-lx-components-settori-industria-layout-desktop-layout-desktop"
      style={{ display: 'contents' }}
    >
      <>
        <PageHead
          title={intl.formatMessage({
            defaultMessage: 'Sistemi Informativi S.r.l. - An IBM company - Settori di Mercato',
            description: 'Settori di Mercato - Page title'
          })}
          description={intl.formatMessage({
            defaultMessage: 'Sistemi Informativi S.r.l. - Settori di Mercato',
            description: 'Settori di Mercato - Page description'
          })}
        />
        <Navbar
          navCssClasses={cn(`${styles.navbarBackground} position-absolute`, {
            noImgBackground: !mainSectionImageUrl
          })}
          navLinkCssClasses={styles.navItem}
          serviceCategories={serviceCategories}
          technologyCategories={technologyCategories}
        />
        <main role="main">
          <Container imageUrl={mainSectionImageUrl} darkTheme={mainSectionDarkTheme}>
            <SezionePrincipale
              translations={mainSectionDescriptions}
              darkTheme={mainSectionDarkTheme}
            />
            {pages?.length > 0 ? (
              <PageNavbar
                selectedNavItem={navMobileState}
                onNavItemClick={setNavMobileState}
                navbarItems={navbarItems}
              />
            ) : null}
          </Container>
          <div>
            {pages?.map((element, index) => (
              <SettoriIndustriaSezione
                key={`section-${index + 1}`}
                urlImage={getObjectValue(element, 'backgroundImage', '')}
                title={getObjectValue(element, 'title', '')}
                subtitle={getObjectValue(element, 'subtitle', '')}
                body={getObjectValue(element, 'body', {})}
                darkTheme={getObjectValue(element, 'darkTheme', false)}
                sectionName={getObjectValue(element, 'id', '')}
                additionalContent={getObjectValue(element, 'additionalContent', [])}
                categoryId={getObjectValue(element, 'categoryId', '')}
              />
            ))}
            {pages?.length > 0 ? (
              <ScrollToTop onClick={() => setNavMobileState({ isOpen: false })} />
            ) : null}
          </div>
        </main>
      </>
    </div>
  );
}
